import valid from 'card-validator';

/**
 * Checks if string is only white spaces
 *
 * @param {string} str
 * @returns {boolean}
 */
const whitespaceValidation = (str) => str.replace(/\s/g, '').length > 0;

/**
 * Validates if the number is a valid Credit card
 *
 * @param {string} creditCard
 * @returns {boolean}
 */
const creditCardValidation = (creditCard) => valid.number(creditCard).isValid;

/**
 * Check if date is a valid credit card expiration date
 *
 * @param {string} date
 * @returns {boolean}
 */
const expirationDateValidation = (date) => {
    const rawArrayDate = date.split("/");
    const rawStringDate = date.replace(/[\D]/g, '');

    if (rawArrayDate.length === 2 && rawStringDate.length === 6) {
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth() + 1;
        const currentYear = currentDate.getFullYear();
        const cardYear = parseInt(rawArrayDate[1]);
        const cardMonth = parseInt(rawArrayDate[0]);

        if (cardMonth > 12 || cardMonth < 1 || cardYear < currentYear) {
            return false;
        }
        else if (cardYear === currentYear && cardMonth < currentMonth) {
            return false;
        }

        return true;
    }

    return false;
}

/**
 * Checks if document is valid
 *
 * @param {string} document
 * @returns {boolean}
 */
const documentValidation = (document) => {
    const rawDocument = document.replace(/[\D]/g, '');
    return (rawDocument.length > 11 ? cnpjValidator(rawDocument) : cpfValidator(rawDocument));
}

/**
 * Tests for a valid CPF
 *
 * @param {string} cpf
 * @returns {boolean}
 */
const cpfValidator = (cpf) => {

    /*
    * Test if is a repeated number
    * Ex: 00000000000, 11111111111, 22222222222
    */
    if (/\b(\d)\1{1,11}\b/.test(cpf)) {
        return false
    }

    // Validate CPF using Brazil's IRS rules
    let sum = 0;
    let rest = 0;
    for (let i = 1; i <= 9; i++) {
        sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i);
    }
    rest = (sum * 10) % 11
    if ((rest === 10) || (rest === 11)) {
        rest = 0;
    }
    if (rest !== parseInt(cpf.substring(9, 10))) {
        return false;
    }

    sum = 0
    for (let t = 1; t <= 10; t++) {
        sum = sum + parseInt(cpf.substring(t - 1, t)) * (12 - t)
    }
    rest = (sum * 10) % 11
    if ((rest === 10) || (rest === 11)) {
        rest = 0
    }
    if (rest !== parseInt(cpf.substring(10, 11))) {
        return false
    }

    return true
}

/**
 * Tests for a valid CNPJ
 *
 * @param {string} cnpj
 * @returns {boolean}
 */
const cnpjValidator = (cnpj) => {

    /*
    * Test if is a repeated number
    * Ex: 00000000000000, 11111111111111, 22222222222
    */
    if (/\b(\d)\1{1,14}\b/.test(cnpj)) {
        return false
    }

    // Validate CNPJ using Brazil's IRS rules
    let len = cnpj.length - 2;
    let numbers = cnpj.substring(len);
    let flag1 = parseInt(numbers.charAt(0));
    let flag2 = parseInt(numbers.charAt(1));

    let calc = requiredIndex => {
        let requiredChars = cnpj.substring(0, requiredIndex);
        let key = requiredIndex - 7;
        let sum = 0;
        let result = 0;

        for (let i = requiredIndex; i >= 1; i--) {
            sum += requiredChars.charAt(requiredIndex - i) * key--;
            if (key < 2){
                key = 9;
            }
        }

        result = 11 - sum % 11;
        return result > 9 ? 0 : result;
    }

    return calc(len) === flag1 && calc(len + 1) === flag2
}

export { whitespaceValidation, documentValidation, creditCardValidation, expirationDateValidation };
